
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "9f2a416b2f0177f0985ef383083b0b648a9d032b",
  "nuxt": {
    "buildId": "7aae8d09-6708-4d24-8ce0-fb6375987f84"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
